import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

let swiper;
let swiperInitialized = false;

document.addEventListener('DOMContentLoaded', function () {

  function initSwiper() {
    if (swiperInitialized) return;

    swiper = new Swiper('.swiper', {
      loop: false,
      spaceBetween: 16,
      slidesPerView: 1.2,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      modules: [Navigation, Pagination, Autoplay],
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });

    swiperInitialized = true;
    handleVariants();

  }

  function handleVariants() {
    const swiperWrapper = document.querySelector('.swiper-wiggle .swiper-wrapper');
    const swiperElement = document.querySelector('.swiper-wiggle');

    if (!swiperWrapper || !swiperElement) return;

    function removeWiggle() {
      swiperWrapper.style.animation = 'none';
    }

    swiperElement.addEventListener('mouseenter', removeWiggle);
    swiperElement.addEventListener('touchstart', removeWiggle);
    swiperElement.addEventListener('click', removeWiggle);

  }

  function waitForVariantAndInitSwiper() {
    const check = () => {
        initSwiper();
    };
    check();
  }

  waitForVariantAndInitSwiper();

});
